import React, { forwardRef } from "react";
import { __ } from "@wordpress/i18n";
import { ApiKeysMgr } from "../ApiKeysComponent";

const UnforwardedApiKeys = (props, ref) => {
	return (
		<div
			{...props}
			ref={ref}
			style={{ minHeight: "50vh" }}
			className="image-hub-settings-apikeys-container"
		>
			<h1>{__("API Keys & Authentication","image-hub")}</h1>
			<h4>
				{__("Manage provider API keys and authentication settings.","image-hub")}
			</h4>
			<ApiKeysMgr />
			<br /> <br />
		</div>
	);
};

export const ApiKeys = forwardRef(UnforwardedApiKeys);
